import { SearchProps } from '~components/form-fields/search';

import { selectLookupStatementDeliveryPreferences } from '~lookups/selectors/statementDeliveryPreferences';
import { selectLookupStatementStatuses } from '~lookups/selectors/statementStatuses';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields: SearchProps = {
  start_date: {
    caption: 'Start Date',
    field: 'start_date',
    type: 'date-range',
    defaultShow: true,
  },
  end_date: {
    caption: 'End Date',
    field: 'end_date',
    type: 'date-range',
  },
  reference: {
    type: 'text-like',
    field: 'reference',
    placeholder: 'Reference',
    caption: 'Reference',
  },
  client: {
    type: 'text-like',
    field: ['first_name', 'surname', 'full_name'],
    placeholder: 'Client Name',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  status: {
    type: 'multi-lookup',
    field: 'status_id',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectLookupStatementStatuses,
  },
  delivery_preference: {
    type: 'multi-lookup',
    field: 'client.statement_delivery_id',
    caption: 'Delivery Preference',
    placeholder: 'All',
    selectorOptions: selectLookupStatementDeliveryPreferences,
  },
};
